import React from "react";
import { Provider } from "mobx-react";
import { ApolloProvider } from "react-apollo";
import { string } from "prop-types";
import SwitchTeamQuery from "./SwitchTeamQuery";
import { ErrorBoundary } from "@utils";
import { Settings, apolloClient } from "@services";
import { FlipgiveStore } from "@stores";

const SwitchTeamApp = (props) => {
  Settings.setDefaultsFromProps(props);
  FlipgiveStore.setCurrentUser(props.currentUser);
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient(Settings.apiUrl)}>
        <Provider FlipgiveStore={FlipgiveStore}>
          <SwitchTeamQuery
            campaignMembersUrl={props.campaignMembersUrl}
            editCampaignUrl={props.editCampaignUrl}
            joinCampaignUrl={props.joinCampaignUrl}
            newCampaignUrl={props.newCampaignUrl}
            personalUserUrl={props.personalUserUrl}
            rootUrl={props.rootUrl}
            switchTeamUrl={props.switchTeamUrl}
            userFundsUrl={props.userFundsUrl}
          />
        </Provider>
      </ApolloProvider>
    </ErrorBoundary>
  );
};

export default SwitchTeamApp;

SwitchTeamApp.propTypes = {
  currentUser: string.isRequired,
  newCampaignUrl: string.isRequired,
  campaignMembersUrl: string.isRequired,
  joinCampaignUrl: string.isRequired,
  switchTeamUrl: string.isRequired,
  personalUserUrl: string.isRequired,
  editCampaignUrl: string.isRequired,
  userFundsUrl: string.isRequired,
  rootUrl: string.isRequired,
};
